import * as React from "react";
import { useField } from "informed";
import { TagsInput } from "react-tag-input-component";
// todo migrate
// import "../../styling/vitalograph/components/_custom-inputs.scss"

interface TagsProps {
    field: string;
    placeholder?: string;
    helper?: string;
}

export const Tags = ({ field, placeholder = "enter tags", helper = "press enter to add new tag" }: TagsProps) => {
    const { fieldState, fieldApi } = useField<string[]>({ field: field });
    const { value } = fieldState;
    const { setValue } = fieldApi;

    return (
        <>
            <TagsInput
                value={value}
                onChange={v => setValue(v)}
                name={field}
                placeHolder={placeholder}
            />
            <em>{helper}</em>
            {fieldApi.getError() ? <span className="field-validation-error">{fieldApi.getError()}</span> : null}
        </>
    );
};